<template>
  <span class="currencySwitcher">
    <div class="dropdown is-mobile-modal" v-if="val && val.currency_code">
      <div
        role="button"
        class="currencySwitcher__current btn"
        id="CurrencySwitcher"
        data-toggle="dropdown"
      >
        <span>{{ getCurrencyLabel(val) }}</span>
        <i class="fas fa-caret-down ml-2"></i>
      </div>
      <div class="background"></div>
      <div class="dropdown-menu" aria-labelledby="CurrencySwitcher">
        <div class="dropdown-content">
          <a class="dropdown-item"
             v-for="(value, i) in currencyList"
             :key="i"
             :value="value"
             :class="value"
             @click="change(value)"
          >
            <span>{{ getCurrencyLabel(value) }}</span>
          </a>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import axios from "axios";

export default {
  name: 'CurrencySwitcher',
  data: () => {
    return {
      val: null
    }
  },
  computed: {
    currencyList: function () {
      return this.$store.getters.getCountrySetting?.list
    },
    current: function () {
      return this.$store.getters.getCountrySetting?.current
    }
  },
  methods: {
    getCurrencyLabel: function (currency) {
      const label = `description_${currency.iso_country_code}_${currency.currency_code}_${currency.device_id}`
      return !this.$t(label) ? label: this.$t(label)
    },
    change: async function (value) {
      if (this.val.currency_code !== value.currency_code) {
        this.$store.commit('setLoading', true)
        await this.changeCurrency(value)
      }
    },
    changeCurrency: async function (newValue) {
      let apiUrl = this.$store.getters.getConfigUrls['apiUrl']
      axios.post(`${apiUrl}change_quote_currency/`, {currency_selected: newValue})
        .then(r => {
          this.val = newValue
          let countrySetting = this.$store.getters.getCountrySetting
          countrySetting['current'] = this.val
          this.$store.commit('setCountrySetting', countrySetting)
          this.$store.commit('setCurrencyChanged', this.$store.getters.getCurrencyChanged+1)
        }).catch(e => {
          console.error(e)
          this.$snotify.error(this.$t('invalid_currency_error'))
          this.$store.commit('setLoading', false)
        }).finally(async () => {})
    }
  },
  mounted () {
    this.val = this.current
  }
}
</script>

<style scoped lang="sass">
.currencySwitcher
  display: flex
  margin-right: .5rem
  &__current.btn
    min-height: 2rem
    padding: 0 .5rem
    display: flex
    align-items: center
    background-color: var(--color-nav)
    color: var(--color-onNav)
    border-color: var(--color-onNav)
    i[class*='caret-']
      opacity: .4
      margin-left: .5rem
.currencySwitcher
  .dropdown-menu
    padding: 0
    min-width: initial
    background-color: var(--color-surface)
    color: var(--color-onSurface)
    border: 1px solid var(--color-overlay-30)
    box-shadow: none
    border-radius: var(--b-radius-md)
  .dropdown-content
    padding: 0
    box-shadow: none
    height: 100%
  .dropdown-item
    padding: 0.25rem 1rem
    transition: background-color .2s ease
    &:hover
      background-color: var(--color-overlay-10)
    &:active
      background-color: var(--color-overlay-15)
      color: var(--color-onSurface)
</style>
